import { render, staticRenderFns } from "./patient-searcher.vue?vue&type=template&id=5b4ccad8&scoped=true&"
import script from "./patient-searcher.ts?vue&type=script&lang=ts&"
export * from "./patient-searcher.ts?vue&type=script&lang=ts&"
import style0 from "./patient-searcher.scss?vue&type=style&index=0&id=5b4ccad8&lang=scss&scoped=true&"
import style1 from "../../shared/styles/common-searcher.scss?vue&type=style&index=1&id=5b4ccad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ccad8",
  null
  
)

export default component.exports